import {
  THEME_MODE_QUERY_PARAM,
  THEME_MODE_STORAGE_KEY,
  ThemeMode,
} from '@modules/theme/constants';
import Locker from 'lockr';

export const getDefaultThemeMode = (): ThemeMode => {
  const searchParams = new URLSearchParams(window.location.search);
  const themeModeQueryParam = searchParams.get(THEME_MODE_QUERY_PARAM);

  if (themeModeQueryParam) {
    return themeModeQueryParam === ThemeMode.DARK
      ? ThemeMode.DARK
      : ThemeMode.LIGHT;
  }

  const themeModeStorage = Locker.get(THEME_MODE_STORAGE_KEY);
  return themeModeStorage === ThemeMode.DARK ? ThemeMode.DARK : ThemeMode.LIGHT;
};
